import { render, staticRenderFns } from "./VIPInfo.vue?vue&type=template&id=d4d53806&scoped=true"
import script from "./VIPInfo.vue?vue&type=script&lang=js"
export * from "./VIPInfo.vue?vue&type=script&lang=js"
import style0 from "./VIPInfo.vue?vue&type=style&index=0&id=d4d53806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d53806",
  null
  
)

export default component.exports